// extracted by mini-css-extract-plugin
export var avatarContainer = "_70-0";
export var avatarTypingWave = "_70-i";
export var gray = "_70-f";
export var green = "_70-c";
export var icon = "_70-9";
export var image = "_70-1";
export var lg = "_70-6";
export var md = "_70-5";
export var presenceDot = "_70-b";
export var red = "_70-d";
export var sm = "_70-4";
export var status = "_70-a";
export var typingDot = "_70-h";
export var typingPill = "_70-g";
export var xl = "_70-7";
export var xs = "_70-3";
export var xxl = "_70-8";
export var xxs = "_70-2";
export var yellow = "_70-e";